module.exports = __webpack_public_path__ + "static/media/ce.f97b47fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/ce.png
// module id = 995
// module chunks = 0